import React from 'react';
import styled from 'styled-components';
import { Banner } from '@repo/design-system';
import { space } from '@repo/design-tokens';

import type { DraftChoiceNotice } from './draftChoice';
import { noticeText } from './draftChoiceText';
import { TWIN_DETAILS_COLUMN } from './twinDetailsLayout';

const Stack = styled.section`
  max-width: ${TWIN_DETAILS_COLUMN};
  margin-bottom: ${space[4]};
`;

/**
 * The top of Twin Details (spec `twin-launch-history-draft-choice`, Failure States): why the draft
 * is shown as saved — production could not be read, or a launch is in progress. The dropped draft
 * and its *Restore* moved into the *Launch history* panel below the form
 * (`twin-launch-history-panel`, maria's ruling 2026-10-06), and from there into Versions, off the
 * twin chip on every step (`twin-details-page-versions`).
 */
const DraftChoiceNotices: React.FC<{ notice: DraftChoiceNotice | null }> = ({ notice }) =>
  notice ? (
    <Stack aria-label="Draft notices">
      <Banner surface="on-glass" tone="info">
        {noticeText(notice)}
      </Banner>
    </Stack>
  ) : null;

export default DraftChoiceNotices;
